module.exports = __webpack_public_path__ + "img/LDBBLALA.cf6aaa6f.jpg";